import { cva } from 'class-variance-authority';

import s from './CTAGroupButton.module.css';

export const ctaGroupButtonVariants = cva(s.button, {
  variants: {
    useSeparator: {
      true: s.button__separator,
    },
  },
});
